import axios from "axios";
import { AUTH_TOKEN_KEY, EV_PROFILE_UPDATED } from "./constants";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem(AUTH_TOKEN_KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Broadcast profile mutations so listeners (e.g. CurrencyContext) can re-sync.
api.interceptors.response.use(
  (response) => {
    try {
      const method = (response.config.method || "").toLowerCase();
      const url = response.config.url || "";
      if (method === "put" && url.replace(/\?.*$/, "").endsWith("/profile")) {
        window.dispatchEvent(new CustomEvent(EV_PROFILE_UPDATED, { detail: response.data }));
      }
    } catch (_) { /* SSR / older browsers */ }
    return response;
  },
  (error) => {
    // Defense-in-depth: normalize `response.data.detail` to a **string** when
    // the backend returned an object (e.g. FastAPI HTTPException with
    // detail={message, support_reference}). Callers still receive the
    // untouched object at `response.data.detail_raw` if they need it.
    // This closes the "Objects are not valid as a React child" crash that
    // black-screened the checkout flow when a `toast.error(err.response.data.detail)`
    // call site received a dict.
    try {
      const d = error?.response?.data?.detail;
      if (d && typeof d === "object" && !Array.isArray(d)) {
        // Preserve original + swap detail for a printable message.
        error.response.data.detail_raw = d;
        error.response.data.detail =
          (typeof d.message === "string" && d.message) ||
          (typeof d.error === "string" && d.error) ||
          "Request failed";
      }
    } catch (_) { /* never throw from an interceptor */ }
    return Promise.reject(error);
  }
);

export const setToken = (t) => {
  if (t) localStorage.setItem(AUTH_TOKEN_KEY, t);
  else localStorage.removeItem(AUTH_TOKEN_KEY);
};
